<template>
  <yioks-content @back="handleBack">
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <div v-for="(item, index) in navList" :key="index" class="btn" :class="{ active: item.componentName === activeCom }" @click="navChange(item)"> {{ item.name }}</div>
      </div>
    </template>

    <template v-slot:content_right>
      <component :is="activeCom"></component>
    </template>
  </yioks-content>
</template>

<script>
import mixinForRouter from '@/views/performance/mixinForRouter';

  export default {
    mixins: [mixinForRouter],
    data() {
      return {
        navList: [
          {
            name: '申报评估考核阶段',
            componentName: 'indicator-phase',
            key: 'indicator_1'
          },
          {
            name: '历史文件库',
            componentName: 'document-library',
            key: 'indicator_2'
          },
        ],
        activeCom: 'document-library',

      }
    },

    computed: {
      statusUrl() {
        const { statusUrl } = this.$route.query;
        return statusUrl || ''
      },
    },

    components: {
      'indicator-phase': () => import('./components/IndicatorPhaseCom'),
      'document-library': () => import('./components/DocumentLibrary'),
    },

    created() {
      this.setActiveCom();
    },

    methods: {
      handleBack() {
        this.$router.push({
          path: '/home/index',
        })
      },

      navChange(navItem) {
        const { componentName } = navItem;
        if(componentName === 'document-library') {
          this.activeCom = componentName;
          this.$router.replace({
            path: this.$route.path,
            query: {
              ...this.$route.query,
              activeCom: componentName
            }
          })
        } else if(componentName === 'indicator-phase') {
          if(this.statusUrl) {
            this.$router.push({
              path: JSON.parse(this.statusUrl),
            });
          } else {
            // 查看阶段
            // const { groupUuid, uuid, stageName } = this.firstIndicatorPhase;
            // this.$router.push({
            //   // path: "upload",
            //   path: "uploadHome",
            //   query: {
            //     groupUuid: groupUuid || '',
            //     // stageName: stageName || '',
            //     targetName: stageName || '',
            //     stageUuid: uuid || '',
            //   },
            // });
            this.$router.back()
          }

        } else {
          console.log('name error for router')
        }

      },

      setActiveCom() {
        const { activeCom } = this.$route.query;
        this.activeCom = activeCom || this.activeCom;
      },
    }
  }
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
</style>

